import { ClientRoomData } from 'models/room/interface';

import { endpoint, EndpointError } from '../endpoint';

export type GetClientRoomParams = {
  id: string;
};
export type GetClientRoomResult = { data: ClientRoomData };
export type GetClientRoomError = EndpointError;

export const getClientRoom = endpoint<GetClientRoomParams, GetClientRoomResult, GetClientRoomError>({
  method: 'GET',
  url: (params) => `/room/get-client-room/${params.id}`,
});
